import ZeroVisitMembersModule from "./ZeroVisitMembersChartModule";
import ZeroVisitMembersSagas from "./redux/zeroVisitsSagas";
import ZeroVisitMembersReducer from "./redux/zeroVisitsReducer";

export default {
  Component: ZeroVisitMembersModule,
  moduleName: "zeroVisits",
  saga: ZeroVisitMembersSagas(),
  reducer: ZeroVisitMembersReducer
};
